import React, { useEffect, useState }/* , { useEffect, useState } */ from 'react';
import { FormControl, FormHelperText, Grid, InputLabel, Select } from '@material-ui/core';
import { hasError } from '../../ConstsAndUtils/utils';
/* import DDLInput from '@jumbo/components/custom/Inputs/DDLInput'; */
//import { Autocomplete } from '@mui/material';
//import { LABEL_INPUT_FONT_SIZE } from '../../ConstsAndUtils/utils';

const Dependencia = props => {
  const {
    dependencia,
    setDependencia,
    tipoAtencionDependencia,
    setTipoAtencionDependencia,
    administracionDependencia,
    setAdministracionDependencia,
    dependenciaList,
    tipoAtencionList,
    /*   tipoAdministracionList, */
    clasificacion,
    setClasificacion,
    complejidad,
    setComplejidad,
    administradorDependencia,
    setAdministradorDependencia,
  } = props;

  const [modalidadError, setModalidadError] = useState('')

  useEffect(() => {
    let aux = []
    dependenciaList.map((item) => {
      aux.push(item.tipo_administracion)
      return null
    })
    setListaTipoAdministracion(aux)
    // eslint-disable-next-line
  }, [dependenciaList])

  useEffect(() => {
    if (dependencia !== "") {
      if (dependencia === "Privados") {
        setAdministradorDependencia("No Aplica")
      }
      let aux = dependenciaList.find(e => e.tipo_administracion === dependencia)
      if (aux) {
        let auxArr = []
        aux.tipo_atencion.map((item) => {
          auxArr.push(item.tipo_atencion)
          return null
        })
        setListaModalidadAtencion(auxArr)
      } else {
        setListaModalidadAtencion([])
      }
    } else {
      setListaModalidadAtencion([])
    }
    // eslint-disable-next-line
  }, [dependencia])

  useEffect(() => {
    if (tipoAtencionDependencia !== "") {
      if (dependencia === "Privados") {
        setAdministradorDependencia("No Aplica")
      }
      let auxDependencia = dependenciaList.find(e => e.tipo_administracion === dependencia)
      let auxModalidad = auxDependencia.tipo_atencion.find(e => e.tipo_atencion === tipoAtencionDependencia)

      let auxLisaAdministrador = []
      let auxListaAdministracion = []
      let auxListraPrestadores = []

      if (auxModalidad) {
        let auxadministrador = auxModalidad.administrador
        let tipo_prestador_inst_desc = auxModalidad.tipo_prestadores_institucional

        auxadministrador.map((item) => {
          auxLisaAdministrador.push(item.administrador)
          item.nombre_administracion.map((item2) => {
            auxListaAdministracion.push(item2.nombre_administracion)
            return null
          })
          return null
        })

        tipo_prestador_inst_desc.map((item) => {
          if (!item.id_ef_administrador) {
            auxListraPrestadores.push(item.tipo_prestador)
          }

          return null
        })

      }

      setListaAdministrador(auxLisaAdministrador)
      setListaAdministracion(auxListaAdministracion)
      setListaTipoPrestador(auxListraPrestadores)

    } else {
      setListaAdministrador(["No Aplica"])
    }
    // eslint-disable-next-line
  }, [tipoAtencionDependencia])

  useEffect(() => {

    if (administradorDependencia !== "" && dependencia !== "" && tipoAtencionDependencia !== "") {
      let auxDependencia = dependenciaList.find(e => e.tipo_administracion === dependencia)
      let auxModalidad = auxDependencia.tipo_atencion.find(e => e.tipo_atencion === tipoAtencionDependencia)

      let auxListaAdministracion = []
      if (auxModalidad) {
        let auxadministrador = auxModalidad.administrador.find(e => e.administrador === administradorDependencia)
        if (auxadministrador) {
          auxadministrador.nombre_administracion.map((item) => {
            auxListaAdministracion.push(item.nombre_administracion)
            return null
          })


          if (auxadministrador.tipo_prestadores_institucional.length > 0) {
            let auxListraPrestadores = []
            auxadministrador.tipo_prestadores_institucional.map((item, index) => {
              auxListraPrestadores.push(item.tipo_prestador)
              return null
            })
            setListaTipoPrestador(auxListraPrestadores)
          } else {
            let tipo_prestador_inst_desc = auxModalidad.tipo_prestadores_institucional
            let auxListraPrestadores = []
            tipo_prestador_inst_desc.map((item) => {
              if (!item.id_ef_administrador) {
                auxListraPrestadores.push(item.tipo_prestador)
              }

              return null
            })
            setListaTipoPrestador(auxListraPrestadores)
          }
        }

      }
      setListaAdministracion(auxListaAdministracion)
    }
    // eslint-disable-next-line
  }, [administradorDependencia])

  const listaComplejidad = [
    {label:'Baja', value:3}, 
    {label:'Media', value:2}, 
    {label:'Alta', value:1}, ];

  const [listaTipoAdministracion, setListaTipoAdministracion] = useState([])
  const [listaModalidadATencion, setListaModalidadAtencion] = useState([])
  const [listaAdministrador, setListaAdministrador] = useState(["No Aplica"])
  const [listaAdministracion, setListaAdministracion] = useState([])
  const [listaTipoPrestador, setListaTipoPrestador] = useState([])



  const isValueInArray = (val, arr) => {
    if (val !== "") {
      return arr.includes(val);
    } else {
      return false
    }

  };

/*   const isModalidadEnabled = () => {
    return !isValueInArray(dependencia, listaTipoAdministracion);
  }; */

  const isAdministradorEnabled = () => {
    if (!isValueInArray(dependencia, listaTipoAdministracion)) {
      return true;
    } else {
      if (dependencia === 'Privados') {
        return true;
      } else {
        if (!isValueInArray(tipoAtencionDependencia, tipoAtencionList)) {
          return true;
        } else {
          return false;
        }
      }
    }
  };

  const isAdministracionEnabled = () => {
    if (!isValueInArray(dependencia, listaTipoAdministracion)) {
      return true;
    } else {
      if (!isValueInArray(tipoAtencionDependencia, tipoAtencionList)) {
        return true;
      } else {
        if (dependencia === 'Públicos') {
          if (tipoAtencionDependencia === 'Cerrada') {
            if (!isValueInArray(administradorDependencia, listaAdministrador)) {
              return true;
            } else {
              return false;
            }
          } else if (tipoAtencionDependencia === 'Abierta') {
            if (!isValueInArray(administradorDependencia, listaAdministrador)) {
              return true;
            } else {
              return false;
            }
          }
        } else if (dependencia === 'Privados') {
          return false;
        }
      }
    }
  };

/*   const isTipoPrestadorEnabled = () => {
    if (!isValueInArray(dependencia, listaTipoAdministracion)) {
      return true;
    } else {
      if (dependencia === 'Privados' || dependencia === 'Públicos') {
        if (!isValueInArray(tipoAtencionDependencia, tipoAtencionList)) {
          return true;
        } else {
          return false;
        }
      }
    }
  }; */

  return (
    <Grid
      container
      item
      xs={12}
      spacing={4}
      style={{
        backgroundColor: 'white',
        paddingTop: 5,
        borderRadius: 5,
        paddingBottom: 5,
        marginTop: 15,
        paddingLeft:15,
        paddingRight:15,
        marginLeft:1,
        marginRight:1,
      }}>
      <Grid item xs={12}>
        <h3>Dependencia</h3>
      </Grid>

      {listaTipoAdministracion.length === 0 ?
        null :
        <Grid item xs={4}>
          <FormControl size="small" fullWidth>
            <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
              {"Tipo Administración"}
            </InputLabel>
            <Select
              disabled
              value={dependencia}
              native
              label="Tipo Administración"
              id="grouped-native-select"
              fullWidth
              variant='outlined'
              onChange={(e) => {
                setDependencia(e.target.value);
                setAdministracionDependencia('0a');
                setTipoAtencionDependencia('0a');
                setAdministradorDependencia('0a');
                setClasificacion('0a');

                setModalidadError('Campo obligatorio')

              }}
            >
              {
                listaTipoAdministracion.map((item, index) => {
                  return <option key={index} value={item}>
                    {item}
                  </option>
                })
              }
            </Select>
          </FormControl>
        </Grid>}

      {tipoAtencionList.length === 0 ?
        null :
        <Grid item xs={4}>
          <FormControl size="small" fullWidth error={hasError(modalidadError)}>
            <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
              {"Modalidad de Atención"}
            </InputLabel>
            <Select
              disabled
              value={tipoAtencionDependencia}
              native
              label="Modalidad de Atención"
              id="grouped-native-select"
              fullWidth
              //style={{ color: hasError(modalidadError) ? 'red' : 'inherit' }}
              variant='outlined'
              onChange={(e) => {
                if(e.target.value==='0a'){
                  setModalidadError('Campo obligatorio')
                }else{
                  setModalidadError('')
                }
                setTipoAtencionDependencia(e.target.value);
                setAdministracionDependencia('0a');
                setAdministradorDependencia('0a');
                setClasificacion('0a');
              }}
            >
              <option key={'0a'} value={'0a'}>Seleccione</option>
              {
                listaModalidadATencion.map((item, index) => {
                  return <option key={index} value={item}>
                    {item}
                  </option>
                })
              }
            </Select>
            <FormHelperText>{modalidadError}</FormHelperText>
          </FormControl>

        </Grid>
      }



      <Grid item xs={4}>
        <FormControl size="small" fullWidth>
          <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
            {"Administrador"}
          </InputLabel>
          <Select
            disabled={isAdministradorEnabled()}
            value={administradorDependencia}
            label="Administrador"
            native
            id="grouped-native-select"
            fullWidth
            variant='outlined'
            onChange={(e) => {
              setAdministradorDependencia(e.target.value);
              setAdministracionDependencia('0a');
            }}
          >
            <option key={'0a'} value={'0a'}>Seleccione</option>
            {
              listaAdministrador?.map((item, index) => {
                return <option key={index} value={item}>
                  {item}
                </option>
              })
            }
          </Select>
        </FormControl>

      </Grid>




      <Grid item xs={4}>
        <FormControl size="small" fullWidth>
          <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
            {"Administración"}
          </InputLabel>
          <Select
            disabled={isAdministracionEnabled()}
            value={administracionDependencia}
            label="Administración"
            native
            id="grouped-native-select"
            fullWidth
            variant='outlined'
            onChange={(e) => {
              setAdministracionDependencia(e.target.value);
            }}
          >
            <option key={'0a'} value={'0a'}>Seleccione</option>
            {
              listaAdministracion?.map((item, index) => {
                return <option key={index} value={item}>
                  {item}
                </option>
              })
            }
          </Select>
        </FormControl>

      </Grid>



      <Grid item xs={4}>
        <FormControl size="small" fullWidth>
          <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
            {"Tipo Prestador Instutucional"}
          </InputLabel>
          <Select
            disabled
            value={clasificacion}
            label="Tipo Prestador Instutucional"
            native
            id="grouped-native-select"
            fullWidth
            variant='outlined'
            onChange={(e) => {
              setClasificacion(e.target.value);
            }}
          >
            <option key={'0a'} value={'0a'}>Seleccione</option>
            {
              listaTipoPrestador?.map((item, index) => {
                return <option key={index} value={item}>
                  {item}
                </option>
              })
            }
          </Select>
        </FormControl>

      </Grid>

      <Grid item xs={4}>
        <FormControl size="small" fullWidth>
          <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
            {"Complejidad"}
          </InputLabel>
          <Select

            value={complejidad}
            native
            label="Complejidad"
            id="grouped-native-select"
            fullWidth
            variant='outlined'
            onChange={(e) => {
              setComplejidad(e.target.value);
            }}
          >
            <option key={'0a'} value={'0a'}>Seleccione</option>
            {
              listaComplejidad?.map((item, index) => {
                return <option key={index} value={item.value}>
                  {item.label}
                </option>
              })
            }
          </Select>
        </FormControl>

      </Grid>

    </Grid>
  );
};

export default Dependencia;
